import { render, staticRenderFns } from "./EditarEstudiosDialogComponent.vue?vue&type=template&id=d61af95c&scoped=true"
import script from "./EditarEstudiosDialogComponent.vue?vue&type=script&lang=js"
export * from "./EditarEstudiosDialogComponent.vue?vue&type=script&lang=js"
import style0 from "./EditarEstudiosDialogComponent.vue?vue&type=style&index=0&id=d61af95c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d61af95c",
  null
  
)

export default component.exports